<template>
  <div>
    <!-- PRINT DIALOG -->


    <div class="p-5 min-w-[450px]">


      <div class="flex flex-col gap-3" data-ui="print-elements" >


        <ul v-if="this?.marketList?.length > 0" class="grid  grid-cols-12 text-center gap-1">
          <li v-for="market in this.marketList" class=" py-1 px-2 cursor-pointer"
              @click="toggleMarketSelection(market) "
              :class="this?.selectedMarkets?.indexOf(market) >= 0 ? 'bg-trader-blue text-white' : 'bg-trader-gray'">
            {{ market.name }}
          </li>
        </ul>

        <div v-if="this?.marketList?.length > 0" class="flex gap-1 justify-end">
          <div class="bg-trader-gray py-1 px-2 cursor-pointer" @click="selectAllMarkets">Alles
            Auswählen
          </div>
          <div class="bg-trader-gray py-1 px-2 cursor-pointer" @click="deselectAllMarkets">Alles
            Abwählen
          </div>
        </div>

        <div class="flex gap-5 items-center mt-5">
          <label>Von Seite:</label>
          <select class="flex-grow bg-trader-gray p-1" v-model="startPage">
            <option v-for="page in maxPageCount" :value="page">{{ page }}</option>
          </select>

          <label>Bis Seite:</label>
          <select class="flex-grow bg-trader-gray p-1" v-model="endPage">
            <option v-for="page in maxPageCount" :value="page">{{ page }}</option>
          </select>
        </div>


        <div class="flex items-center">
          <div class="flex flex-col">
            <div class="flex gap-2">
              <label class="flex-grow">Platzhalter Nummerieren:</label>
              <input type="checkbox" class="bg-trader-gray p-1" v-model="localShowNumbers">
            </div>

            <div class="flex gap-2">
              <label class="flex-grow">Notizen anzeigen:</label>
              <input type="checkbox" class="bg-trader-gray p-1" v-model="localShowNotes">
            </div>
          </div>
          <div class="flex-grow"></div>
        </div>


        <!-- Drucken oder Abbrechen Buttons -->
        <div class="flex gap-1 justify-end mt-5">
          <div class="bg-trader-red text-trader-dark-red py-1 px-2 cursor-pointer" @click="close">Abbrechen</div>
          <a class="bg-trader-green text-trader-dark-green py-1 px-2 cursor-pointer" :href="printUrl" target="_blank" @click="close();">Drucken</a>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus";
import {mapState} from "vuex";

export default {
  props: {
    marketList: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    },
    maxPageCount: {
      type: Number,
      default: 1,
    },
    magazineId: {
      type: Number,
      default: 0,
    },
    activePage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      startPage: this.activePage || 1,
      endPage: this.activePage || 1,
      selectedMarkets: [],
      showMoreInfos: {},
      localShowNumbers: this.showNumbers,
      localShowNotes: this.showNotes,
    }
  },
  computed: {
    printUrl() {
      return `/print/${this.magazineId}/${this.startPage}/${this.endPage}/${this.localShowNumbers}/${this.localShowNotes}/${this.selectedMarkets.map(market => market.marketId).join(',')}`;
    },
    ...mapState('settings', ['showNumbers', 'showNotes']),
  },
  methods: {
    close() {
      eventBus.closeModal();
    },
    toggleMarketSelection(market) {
      if (this.selectedMarkets.indexOf(market) >= 0) {
        this.selectedMarkets = this.selectedMarkets.filter(selectedMarket => selectedMarket !== market);
      } else {
        this.selectedMarkets.push(market);
      }
    },
    selectAllMarkets() {
      this.selectedMarkets = this.marketList;
    },
    deselectAllMarkets() {
      this.selectedMarkets = [];
    },
  },
  mounted(){
      this.localShowNumbers = this.showNumbers;
      this.localShowNotes = this.showNotes;
  }
}

</script>
